import { render, staticRenderFns } from "./CharSheetSavageWorld.vue?vue&type=template&id=483b32a1&"
import script from "./CharSheetSavageWorld.vue?vue&type=script&lang=js&"
export * from "./CharSheetSavageWorld.vue?vue&type=script&lang=js&"
import style0 from "./CharSheetSavageWorld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports